import styled from "styled-components";

export const Home = styled.div`
  position: relative;
  z-index: 5;
`;
